import { createEtDom, mountedToDom } from "utils";
import { getIsMobile } from "utils/device";

const mountedToHeader = (): void => {
  mountedToDom(["HeaderLinkBarBefore"], () => {
    return createEtDom("div", false);
  });
};

const mountedToDrawer = (): void => {
  mountedToDom(["HeaderDrawerMenuContentBottom"],() => {
    return createEtDom("div", true);
  });
};

const translateVenue = function () {
  const inOrderPge = new RegExp(/\/order?-\w+|orders\/\d+/).test(
    location.pathname
  );
  const mobileWidth = 767; // 移动端屏幕宽度临界值
  const isMobile = getIsMobile(mobileWidth); // 是否是移动端

  if (inOrderPge) {
    createEtDom('div', isMobile)

    return;
  }

  if (isMobile) {
    mountedToDrawer()
  } else {
    mountedToHeader();
  }
};

export { translateVenue };
